import { StateSchema } from 'app/config/storeConfig/types';
import { ComponentType } from 'react';

export const getSpecialPromotionContent = (state: StateSchema): Nullable<ComponentType> => state.specialPromotionModal.Content;
